<template>
    <div class="app-container">
        <jf-table
            :loading="loading"
            :columns="tableColumn"
            :data="dataList"
            :toolbar-config="tableToolbar"
            :query-params="queryParams"
            @checkbox-change="checkboxChangeEvent"
            @page-change="handlePageChange"
            :total="total"
            @change="tableChange"
            @handleQuery="handleQuery"
        >
            <template slot="query_qarams_item">
                <el-form-item label="院系" prop="dept_no">
                    <dept-select
                        v-model="queryParams.dept_no"
                        placeholder="请选择院系"
                        valueField="no"
                        size="small"
                    />
                </el-form-item>
                <el-form-item label="专业" prop="major_no">
                    <major-select
                        v-model="queryParams.major_no"
                        placeholder="请选择专业"
                        valueField="no"
                        size="small"
                        :dept_no="queryParams.dept_no"
                    />
                </el-form-item>
                <el-form-item label="年级" prop="grade">
                    <el-input
                        v-model="queryParams.grade"
                        placeholder="请输入年级"
                        clearable
                        size="small"
                    />
                </el-form-item>
            </template>
            <template slot="toolbar_btn_left">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    v-hasPermi="['/stuc/stucurriculum/add']"
                    >新增</el-button
                >

                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    v-hasPermi="['/stuc/stucurriculum/get', '/stuc/stucurriculum/edit']"
                    >修改</el-button
                >

                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    v-hasPermi="['/stuc/stucurriculum/del']"
                    >删除</el-button
                >

                <el-button
                    type="warning"
                    size="mini"
                    @click="handleImport"
                    v-hasPermi="['/stuc/stucurriculum/import']"
                >
                    <i class="iconfont icon-daoru_o"></i>
                    导入
                </el-button>
            </template>
            <template slot="toolbar_btn_row" slot-scope="{ row }">
                <el-button
                    size="mini"
                    type="text"
                    icon="iconfont icon-daochu_o"
                    @click="handleExport(row)"
                    v-hasPermi="['/stuc/stucurriculum/export']"
                    >导出
                </el-button>
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="handleUpdate(row)"
                    >修改
                </el-button>
                <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    @click.stop="handleDelete(row)"
                    >删除
                </el-button>
            </template>
        </jf-table>
        
        <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="open"
            width="1400px"
            append-to-body
        >
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="院系" prop="dept_no">
                            <dept-select
                                v-model="form.dept_no"
                                :defaultLabel="form.dept_name"
                                placeholder="请选择院系"
                                valueField="no"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="专业" prop="major_no">
                            <major-select
                                v-model="form.major_no"
                                :defaultLabel="form.major_name"
                                placeholder="请选择专业"
                                valueField="no"
                                :dept_no="form.dept_no"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="专业层次" prop="grade">
                            <el-input
                                v-model="form.grade"
                                placeholder="请输入年级"
                                clearable
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注信息" prop="remark">
                            <el-input
                                v-model="form.remark"
                                placeholder="请输入备注信息"
                                clearable
                                type="textarea"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    学分要求
                    <el-button @click="addRequirement()">添加</el-button>
                </el-row>
                <el-row>
                    <el-table :data="form.requirement_list">
                        <el-table-column label="课程类别" prop="category">
                            <template slot-scope="scope">
                                <dict-select v-model="form.requirement_list[scope.$index].category" placeholder="请选择课程类别" type="stuc_course_category" />
                            </template>
                        </el-table-column>
                        <el-table-column label="应修学分" prop="credit">
                            <template slot-scope="scope">
                                <el-input v-model="form.requirement_list[scope.$index].credit" placeholder="请输入应修学分" clearable/>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="40">
                            <template slot-scope="scope">
                                <el-button @click="delRequirement(scope.$index)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row>
                    课程设置
                    <el-button @click="addDetail()">添加</el-button>
                </el-row>
                <el-row>
                    <el-table :data="form.detail_list" :cell-style="{ padding: '0px'}" class="detail-table">
                        <el-table-column label="课程类别" prop="category" min-width = 80>
                            <template slot-scope="scope">
                                <dict-select v-model="form.detail_list[scope.$index].category" type="stuc_course_category" />
                            </template>
                        </el-table-column>
                        <el-table-column label="核心课程" prop="core" min-width = 40>
                            <template slot-scope="scope">
                                <el-switch v-model="form.detail_list[scope.$index].core" active-value="1" inactive-value="0"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="课程名称" prop="name" min-width = 120>
                            <template slot-scope="scope">
                                <el-input v-model="form.detail_list[scope.$index].name"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="课程代码" prop="no"  min-width = 80>
                            <template slot-scope="scope">
                                <el-input v-model="form.detail_list[scope.$index].no"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="学分" prop="credit" min-width = 40>
                            <template slot-scope="scope">
                                <el-input v-model="form.detail_list[scope.$index].credit"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="必修" prop="required" min-width = 40>
                            <template slot-scope="scope">
                                <el-switch v-model="form.detail_list[scope.$index].required" active-value="1" inactive-value="0"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="总学时" prop="total_period" min-width = 40>
                            <template slot-scope="scope">
                                <el-input v-model="form.detail_list[scope.$index].total_period"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="学时分配">
                            <el-table-column label="讲授" prop="lession_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].lession_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="实践" prop="pratice_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].pratice_period"/>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="各学期学时分配">
                            <el-table-column label="一" prop="turn1_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn1_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="二" prop="turn2_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn2_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="三" prop="turn3_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn3_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="四" prop="turn4_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn4_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="五" prop="turn5_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn5_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="六" prop="turn6_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn6_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="七" prop="turn7_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn7_period"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="八" prop="turn8_period" min-width = 40>
                                <template slot-scope="scope">
                                    <el-input v-model="form.detail_list[scope.$index].turn8_period"/>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="40">
                            <template slot-scope="scope">
                                <el-button @click="delDetail(scope.$index)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">返 回</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="upload.title"
            :visible.sync="upload.open"
            width="400px"
            append-to-body
        >
            <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx"
                :headers="upload.headers"
                :action="upload.url + '?update=' + upload.update"
                :disabled="upload.isUploading"
                :on-progress="handleImportProgress"
                :on-success="handleImportSuccess"
                :on-error="handleImportError"
                :auto-upload="false"
                drag
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                    <el-checkbox
                        v-model="upload.update"
                    />是否更新已经存在的数据
                    <el-link
                        type="info"
                        style="font-size: 12px"
                        @click="handleImportTemplate"
                        >下载模板</el-link
                    >
                    <el-link
                        type="info"
                        style="font-size: 12px"
                        @click="handleImportReport"
                        >下载报告</el-link
                    >
                </div>
                <div class="el-upload__tip" style="color: red" slot="tip">
                    提示：仅允许导入“xlsx”格式文件！
                </div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitImportForm"
                    >确 定</el-button
                >
                <el-button @click="upload.open = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Qs from "qs";
import { getAccessToken } from "@/utils/tokenTool";
import {
    listStuCurriculum,
    getStuCurriculum,
    addStuCurriculum,
    editStuCurriculum,
    delStuCurriculum,
} from "@/api/stuc/stu_curriculum";
export default {
    name: "stuc-stucurriculum-list",
    data() {
        return {
            tableToolbar: {
                perfect: false,
                zoom: true,
                custom: false,
                refresh: {
                    query: this.handleQuery,
                },
                slots: {
                    buttons: "toolbar_buttons",
                },
            },
            tableColumn: [
                { type: "checkbox", width: 60, fixed: "left" },
                {
                    field: "id",
                    title: "id",
                    minWidth: 120,
                    fixed: "left",
                    visible: false,
                },
                { field: "dept_name", title: "院系", minWidth: 120 },
                { field: "major_name", title: "专业", minWidth: 120 },
                { field: "grade", title: "年级", minWidth: 120 },
                {
                    field: "create_by",
                    title: "创建者",
                    minWidth: 120,
                    visible: false,
                },
                {
                    field: "create_time",
                    title: "创建时间",
                    minWidth: 120,
                    formatter: "formatDate",
                    visible: false,
                    form_type:3
                },
                {
                    field: "update_by",
                    title: "更新者",
                    minWidth: 120,
                    visible: false,
                },
                {
                    field: "update_time",
                    title: "更新时间",
                    minWidth: 120,
                    formatter: "formatDate",
                    form_type:3
                },
                { field: "remark", title: "备注信息", minWidth: 120 },
            ],
            loading: true,
            ids: [],
            single: true,
            multiple: true,
            total: 0,
            dataList: [],
            title: "",
            open: false,
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                id: undefined,
                dept_no: undefined,
                major_no: undefined,
                grade: undefined,
            },
            form: {
                requirement_list: [],
                detail_list: [],
            },
            upload: {
                open: false,
                title: "",
                isUploading: false,
                update: false,
                headers: { Authorization: getAccessToken() },
                url: process.env.VUE_APP_BASE_API + "/stuc/stucurriculum/import",
            },
            rules: {
                dept_no: [
                    {
                        required: true,
                        message: "院系不能为空",
                        trigger: "blur",
                    },
                ],
                major_no: [
                    {
                        required: true,
                        message: "专业不能为空",
                        trigger: "blur",
                    },
                ],
                grade: [
                    {
                        required: true,
                        message: "年级不能为空",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //列表的筛选和排序
        tableChange(e) {},
        getList() {
            this.loading = true;
            this.ids = [];
            this.single = true;
            this.multiple = true;

            listStuCurriculum(this.queryParams).then((response) => {
                this.dataList = response.data.list;
                this.total = response.data.total;
                this.loading = false;
            });
        },

        dictFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            if (col.dictData) {
                const values = e.cellValue ? e.cellValue.split(",") : [];
                const labels = [];
                for (let i = 0; i < values.length; i++) {
                    const v = values[i];
                    for (let j = 0; j < col.dictData.values.length; j++) {
                        const item = col.dictData.values[j];
                        if (v == item.key) {
                            labels.push(item.value);
                            break;
                        }
                    }
                }
                return labels.join(",");
            }
            return e.cellValue;
        },

        cancel() {
            this.open = false;
            this.reset();
        },

        reset() {
            this.form = {
                dept_no: undefined,
                major_no: undefined,
                grade: undefined,
            };
            this.resetForm("form");
        },

        handleQuery(e) {
           if(e){    this.queryParams = this.deepCopy(e);};
            this.queryParams.pageNum = 1;
            this.getList();
        },

        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },

        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加";
        },

        handleUpdate(row) {
            this.reset();
            const id = row.id || (this.ids.length > 0 ? this.ids[0] : "");
            getStuCurriculum(id).then((response) => {
                this.form = response.data;
                this.open = true;
                this.title = "修改";
            });
        },

        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    var data = this.form;
                    if (data.requirement_list == undefined) {
                        data.requirement_list = [];
                    }
                    if (data.detail_list == undefined) {
                        data.detail_list = [];
                    }

                    if (data.id != null) {
                        editStuCurriculum(data).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("修改成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    } else {
                        addStuCurriculum(data).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("新增成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    }
                }
            });
        },

        handleDelete(row) {
            const ids =
                row.id || (this.ids.length > 0 ? this.ids.join(",") : "");
            this.$confirm('确定删除id为"' + ids + '"的数据项?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(function () {
                    return delStuCurriculum(ids);
                })
                .then(() => {
                    setTimeout(() => {
                        this.getList();
                    }, 300);
                    this.msgSuccess("删除成功");
                })
                .catch(function () {});
        },

        checkboxChangeEvent({ records }) {
            this.ids = records.map((item) => item.id);
            this.single = records.length != 1;
            this.multiple = !records.length;
        },

        handlePageChange({ currentPage, pageSize }) {
            if (this.queryParams.pageSize == pageSize) {
                this.getList();
            } else {
                this.queryParams.pageSize = pageSize;
                this.handleQuery();
            }
        },

        handleImport() {
            this.upload.title = "数据导入";
            this.upload.update = false;
            this.upload.open = true;
        },

        handleImportProgress(event, file, fileList) {
            this.upload.isUploading = true;
            if (event.percent == 100) {
                this.upload.open = false;
                this.upload.loading = this.$loading({
                    lock: true,
                    text: "正在导入数据",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
        },

        handleImportSuccess(response, file, fileList) {
            console.log(response);
            if (this.upload.loading) {
                this.upload.loading.close();
            }
            this.upload.open = false;
            this.upload.isUploading = false;
            this.$refs.upload.clearFiles();
            if (response.code == 0) {
                const msg =
                    "导入成功" +
                    response.data.success_count +
                    "条数据，失败" +
                    response.data.fail_count +
                    "条数据" +
                    (response.data.msg ? "，" + response.data.msg : "");
                //this.$alert(msg, "提示", { dangerouslyUseHTMLString: true });
                this.$confirm(msg, "提示", {
                    distinguishCancelAndClose: true,
                    confirmButtonText: "确定",
                    cancelButtonText: "下载导入报告",
                })
                    .then(() => {})
                    .catch((action) => {
                        if (action === "cancel") {
                            // 下载导入报告
                            this.downloadbyurl("/stuc/stucurriculum/importReport");
                        }
                    });
            } else {
                this.$alert(response.msg, "提示", {
                    dangerouslyUseHTMLString: true,
                });
            }
            this.getList();
        },

        handleImportError(err, file, fileList) {
            if (this.upload.loading) {
                this.upload.loading.close();
            }
            this.upload.isUploading = false;
            this.$alert("导入失败", "提示", { dangerouslyUseHTMLString: true });
        },

        submitImportForm() {
            this.$refs.upload.submit();
        },

        handleImportTemplate() {
            this.downloadbyurl("/stuc/stucurriculum/importTemplate");
        },

        handleImportReport() {
            this.downloadbyurl("/stuc/stucurriculum/importReport");
        },

        handleExport(row) {
            this.$confirm("确定导出数据吗?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.downloadbyurl("/stuc/stucurriculum/export?id=" + row.id);
            });
        },
        
        addRequirement() {
            if (this.form.requirement_list == undefined) {
                this.form.requirement_list = [];
            }

            this.form.requirement_list.push({});
        },

        delRequirement(index) {
            this.form.requirement_list.splice(index, 1);
        },
        
        addDetail() {
            if (this.form.detail_list == undefined) {
                this.form.detail_list = [];
            }

            this.form.detail_list.push({});
        },

        delDetail(index) {
            this.form.detail_list.splice(index, 1);
        },

    },
};
</script>
<style>
.detail-table div.cell {
    padding: 0px 1px !important;
};

.detail-table input.el-input__inner {
    padding: 0px 4px !important;
};
</style>